<script>import { derived } from "svelte/store";
import { getState } from "../command.js";
export let alwaysRender = false;
export let asChild = false;
const state = getState();
const render = derived(state, ($state) => !$state.search);
const attrs = {
  "data-cmdk-separator": "",
  role: "separator"
};
</script>

{#if $render || alwaysRender}
	{#if asChild}
		<slot {attrs} />
	{:else}
		<div {...attrs} {...$$restProps}></div>
	{/if}
{/if}
